import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as type from '../constants/actionConstants';
import * as actions from '../actions/LoginAction.js';
import {  getMenuServ } from '../services/LoginService';

import { httpStatus } from '../constants/variableConstant';
export const stateGlobal = (state) => state

export function* getMenuAct({ payload }) {
    try {
        const repos = yield call(getMenuServ, payload);
        yield put(
            actions.getMenuActSuccess(repos),
        );
       
        
        
    } catch (err) {
    }
}

export const login = [
    takeLatest(type.loginConst.GET_MENUS, getMenuAct),
]
